const TOGGLE_VIEW = 'TOGGLE_VIEW';

const toggleView = (view) => {
    return {
        type: TOGGLE_VIEW,
        view
    };
};

export {toggleView, TOGGLE_VIEW};